import React from 'react';

/**
 * Wrapper that uses CSS `content-visibility: auto` to defer rendering of
 * off-screen sections without unmounting them. Keeps the DOM intact for
 * anchor links, in-page search, screen readers and SEO crawlers.
 *
 * `contain-intrinsic-size` reserves the height before the section is
 * painted, so CLS stays at zero.
 */
interface LazySectionProps {
  children: React.ReactNode;
  /** Reserved height before the section renders. Default: 600px. */
  minHeight?: number;
  className?: string;
}

const LazySection: React.FC<LazySectionProps> = ({
  children,
  minHeight = 600,
  className,
}) => (
  <div
    className={className}
    style={{
      contentVisibility: 'auto',
      containIntrinsicSize: `${minHeight}px`,
    }}
  >
    {children}
  </div>
);

export default LazySection;
